import {
  addUpdateCategory,
  getCategories,
  deleteCategory,
  getDocumentsByCategory,
  addDocument,
  deleteDocument,
} from "./services/forms-api";

const FETCH_GENERAL_FORMS = "forms/FETCH_GENERAL_FORMS";
const SET_FORMS_LOADING = "forms/SET_FORMS_LOADING";
const ADD_FORMS_CATEGORY = "forms/ADD_FORMS_CATEGORY";

const FETCH_FORMS_CATEGORY = "forms/FETCH_FORMS_CATEGORY";
const SET_FORMS_CATEGORY = "forms/SET_FORMS_CATEGORY";
const SET_SELECTED_FORMS_CATEGORY = "forms/SET_SELECTED_FORMS_CATEGORY";
const ADD_UPDATE_FORMS_CATEGORY = "forms/ADD_UPDATE_FORMS_CATEGORY";
const DELETE_FORMS_CATEGORY = "forms/DELETE_FORMS_CATEGORY";

const FETCH_FORMS_CATEGORY_DOCUMENTS = "forms/FETCH_FORMS_CATEGORY_DOCUMENTS";
const SET_FORMS_CATEGORY_DOCUMENTS = "forms/SET_FORMS_CATEGORY_DOCUMENTS";
const SET_SELECTED_FORMS_CATEGORY_DOCUMENT = "forms/SET_SELECTED_FORMS_CATEGORY_DOCUMENT";
const ADD_FORMS_CATEGORY_DOCUMENT = "forms/ADD_FORMS_CATEGORY_DOCUMENT";
const DELETE_FORMS_CATEGORY_DOCUMENT = "forms/DELETE_FORMS_CATEGORY_DOCUMENT";

export const formsStore = {
  state: {
    forms: { isLoading: false, category: [] },
    category: [],
    selectedCategory: null,
    documents: [],
    selectedDocument: null,
  },
  mutations: {
    [SET_FORMS_LOADING](state, isLoading) {
      state.forms.isLoading = isLoading;

      if (isLoading) {
        state.forms.category = [];
      }
    },
    [ADD_FORMS_CATEGORY](state, category) {
      state.forms.category = [...state.forms.category, category];
    },
    [SET_FORMS_CATEGORY](state, { category }) {
      state.category = category.sort((a, b) => a.orderId - b.orderId);
    },
    [SET_SELECTED_FORMS_CATEGORY](state, { selectedCategory }) {
      state.selectedCategory = { ...selectedCategory };
    },
    [SET_FORMS_CATEGORY_DOCUMENTS](state, documents) {
      state.documents = [...documents];
    },
    [SET_SELECTED_FORMS_CATEGORY_DOCUMENT](state, selectedDocument) {
      state.selectedDocument = { ...selectedDocument };
    },
  },
  getters: {
    forms: (state) => state.forms,
    category: (state) => state.category,
    selectedCategory: (state) => state.selectedCategory,
    documents: (state) => state.documents,
    selectedDocument: (state) => state.selectedDocument,
  },
  actions: {
    [FETCH_GENERAL_FORMS]: async ({ commit }) => {
      // eslint-disable-next-line no-useless-catch
      try {
        commit(SET_FORMS_LOADING, true);
        const resp = await getCategories("PublicDocumentType");
        if (resp.data) {
          const docResp = await getDocumentsByCategory('');
          const allDocs = docResp.data;
          await Promise.all(
            resp.data.map(async (category) => {
              const docs = allDocs.filter(
                (item) => item.documentType === category.message,
              );
              if (docs && docs.length > 0) {
                commit(ADD_FORMS_CATEGORY, {
                  ...category,
                  documents: docs,
                });
              }
            }),
          ).then(() => {
            commit(SET_FORMS_LOADING, false);
          });
        }
      } catch (error) {
        throw error;
      }
    },

    [FETCH_FORMS_CATEGORY]: async ({ commit }) => {
      // eslint-disable-next-line no-useless-catch
      try {
        const resp = await getCategories("PublicDocumentType");
        commit(SET_FORMS_CATEGORY, {
          category: resp.data || [],
        });
      } catch (error) {
        throw error;
      }
    },

    [SET_SELECTED_FORMS_CATEGORY]: async ({ commit }, payload) => {
      try {
        commit(SET_SELECTED_FORMS_CATEGORY, { selectedCategory: payload });
      } catch (error) {
        commit(SET_SELECTED_FORMS_CATEGORY, null);
        throw error;
      }
    },

    [ADD_UPDATE_FORMS_CATEGORY]: async ({ dispatch }, payload) => {
      // eslint-disable-next-line no-useless-catch
      try {
        await addUpdateCategory(payload);
        await dispatch(FETCH_FORMS_CATEGORY);
        await dispatch(FETCH_GENERAL_FORMS);
      } catch (error) {
        throw error;
      }
    },

    [DELETE_FORMS_CATEGORY]: async ({ dispatch }, { id }) => {
      // eslint-disable-next-line no-useless-catch
      try {
        await deleteCategory(id);
        await dispatch(FETCH_FORMS_CATEGORY);
        await dispatch(FETCH_GENERAL_FORMS);
      } catch (error) {
        throw error;
      }
    },

    [FETCH_FORMS_CATEGORY_DOCUMENTS]: async ({ commit }, payload) => {
      // eslint-disable-next-line no-useless-catch
      try {
        const resp = await getDocumentsByCategory(payload);
        commit(SET_FORMS_CATEGORY_DOCUMENTS, resp.data);
      } catch (error) {
        throw error;
      }
    },

    [SET_SELECTED_FORMS_CATEGORY_DOCUMENT]: async ({ commit }, document) => {
      try {
        commit(SET_SELECTED_FORMS_CATEGORY_DOCUMENT, document);
      } catch (error) {
        commit(SET_SELECTED_FORMS_CATEGORY_DOCUMENT, null);
        throw error;
      }
    },

    [ADD_FORMS_CATEGORY_DOCUMENT]: async ({ dispatch }, { document, category }) => {
      // eslint-disable-next-line no-useless-catch
      try {
        await addDocument(document);
        await dispatch(FETCH_FORMS_CATEGORY_DOCUMENTS, category);
        await dispatch(FETCH_GENERAL_FORMS);
      } catch (error) {
        throw error;
      }
    },

    [DELETE_FORMS_CATEGORY_DOCUMENT]: async ({ commit, dispatch }, { id, category }) => {
      try {
        await deleteDocument(id);
        await dispatch(FETCH_FORMS_CATEGORY_DOCUMENTS, category);
        await dispatch(FETCH_GENERAL_FORMS);
      } catch (error) {
        commit(SET_SELECTED_FORMS_CATEGORY_DOCUMENT, null);
        throw error;
      }
    },
  },
};

export {
  FETCH_GENERAL_FORMS,
  FETCH_FORMS_CATEGORY,
  SET_SELECTED_FORMS_CATEGORY,
  ADD_UPDATE_FORMS_CATEGORY,
  DELETE_FORMS_CATEGORY,
  FETCH_FORMS_CATEGORY_DOCUMENTS,
  SET_SELECTED_FORMS_CATEGORY_DOCUMENT,
  ADD_FORMS_CATEGORY_DOCUMENT,
  DELETE_FORMS_CATEGORY_DOCUMENT,
};
